export const MAIN_MANIFEST = "/manifest.webmanifest";
export const ON_DEMAND_MANIFEST = "/manifest-on-demand.webmanifest";

const APP_TITLES = {
  [MAIN_MANIFEST]: { title: "GFN Soul NYC", icon: "/apple-touch-icon.png" },
  [ON_DEMAND_MANIFEST]: { title: "GFN On Demand", icon: "/apple-touch-icon-ondemand.png" },
};

export function applyManifest(href) {
  if (typeof document === "undefined") return;
  const link = document.querySelector('link[rel="manifest"]');
  if (link && link.getAttribute("href") !== href) link.setAttribute("href", href);
  const meta = APP_TITLES[href];
  if (!meta) return;
  const titleTag = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (titleTag) titleTag.setAttribute("content", meta.title);
  const touch = document.querySelector('link[rel="apple-touch-icon"]');
  if (touch) touch.setAttribute("href", meta.icon);
}

// Which manifest Chrome actually read when this document first loaded (set in index.html)
export function loadedManifest() {
  if (typeof window === "undefined") return MAIN_MANIFEST;
  return window.__gfnLoadedManifest || MAIN_MANIFEST;
}

export const isStandaloneDisplay = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true);
